import script from "./BackgroundCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundCanvas.vue?vue&type=script&setup=true&lang=js"

import "./BackgroundCanvas.vue?vue&type=style&index=0&id=931eb49e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-931eb49e"]])

export default __exports__